export const getProjectId = (id: string) => {
  return Number(id.replace('gid://gitlab/Project/', ''));
};

export const getIssueId = (id: string) => {
  return Number(id.replace('gid://gitlab/Issue/', ''));
};

export const getNoteId = (id: string) => {
  return Number(id.replace('gid://gitlab/Note/', ''));
};
